import $ from 'zepto';
import { getXoom } from '../xoom';
import { $$$ } from '../../utils/legacy';
import initUIManager from '../ui/UIManager';

const init = () => {
  const xoom = getXoom();
  const elements = {};
  const NUMBERS = '1234567890';
  const CURRENCY_CHARACTERS = '.$';
  const DECIMAL_CHARACTER = '.';
  const CURRENCY = NUMBERS + CURRENCY_CHARACTERS;
  const DECIMAL = NUMBERS + DECIMAL_CHARACTER;
  const ALLOW_CONTROL_CHARACTERS = 1; // control characters are tab, arrow keys, delete, backspace, etc
  const INTL_PHONE_CHARACTERS = `${NUMBERS} +()-`;
  const NUMBERS_REGEX = new RegExp('^[0-9]+$');
  const DECIMAL_REGEX = new RegExp(`^[${DECIMAL}]+$`);
  const CURRENCY_REGEX = new RegExp(`^[${CURRENCY}]+$`);
  const INTL_PHONE_CHARACTERS_REGEX = new RegExp(`^[${INTL_PHONE_CHARACTERS}]+$`);

  if (!xoom.UIManager) {
    initUIManager();
  }

  function isAllowed(eventObject, allowedCharacters, isControlCharactersAllowed) {
    // allowing eventObject.metaKey makes Firefox allow pasting into the field, the same as all other browsers.
    if (isControlCharactersAllowed && (eventObject.which < 32 || eventObject.metaKey)) {
      return true;
    } // allow control characters (tab, arrow keys, delete key)
    return allowedCharacters.indexOf(String.fromCharCode(eventObject.which)) !== -1;
  }

  function isMatch(text, regexpression) {
    return regexpression.test(text);
  }

  function filterElement(eventObject, pastedText) {
    const element = eventObject.target;
    const { id } = element;
    const elementObject = elements[id];
    let isValidInput = true;

    $.each(elementObject, (index, value) => {
      if (value(eventObject, pastedText) === false) {
        isValidInput = false;
      }
    });

    return isValidInput;
  }

  function filterPaste(e) {
    let pastedText;

    if (window.clipboardData && window.clipboardData.getData) { // IE
      pastedText = window.clipboardData.getData('Text');
    } else if (e.clipboardData && e.clipboardData.getData) { // other browsers
      pastedText = e.clipboardData.getData('Text');
    } else if (e.originalEvent.clipboardData) {
      pastedText = e.originalEvent.clipboardData.getData('Text'); // jQuery event object property - fallback
    }

    if (typeof pastedText === 'string') {
      pastedText = pastedText.trim();
    }

    if (pastedText === '') {
      pastedText = false;
    }

    return filterElement(e, pastedText);
  }

  function filterDrop(e) {
    let pastedText;

    if (e.originalEvent && e.originalEvent.dataTransfer) {
      pastedText = e.originalEvent.dataTransfer.getData('Text');
    }

    if (typeof pastedText === 'string') {
      pastedText = pastedText.trim();
    }

    if (pastedText === '') {
      pastedText = false;
    }

    return filterElement(e, pastedText);
  }

  function remove(elementId) {
    const element = elements[elementId];
    if (element) {
      // remove bindings
      $$$(elementId).unbind('keypress', filterElement).unbind('paste', filterPaste);

      // remove item in object so that if we add it again, it doesn't reference the old element.
      delete elements[elementId];
    }
  }

  const filters = {
    numbers(eventObject, pastedText) {
      if (pastedText) {
        return isMatch(pastedText, NUMBERS_REGEX);
      }
      return isAllowed(eventObject, NUMBERS, ALLOW_CONTROL_CHARACTERS);
    },
    currency(eventObject, pastedText) {
      if (pastedText) {
        return isMatch(pastedText, CURRENCY_REGEX);
      }
      let allowedCharacter = isAllowed(eventObject, CURRENCY, ALLOW_CONTROL_CHARACTERS);
      const character = String.fromCharCode(eventObject.which);

      // check to see if the character is a currency character which can only appear once in a field
      if (CURRENCY_CHARACTERS.indexOf(character) !== -1) {
        if (eventObject.target.value.indexOf(character) !== -1) {
          allowedCharacter = false;
        }
      }

      return allowedCharacter;
    },
    decimal(eventObject, pastedText) {
      if (pastedText) {
        return isMatch(pastedText, DECIMAL_REGEX);
      }

      let allowedCharacter = isAllowed(eventObject, DECIMAL, ALLOW_CONTROL_CHARACTERS);
      const character = String.fromCharCode(eventObject.which);

      // check to see if the character is a decimal character which can only appear once in a field
      if (DECIMAL_CHARACTER.indexOf(character) !== -1) {
        if (eventObject.target.value.indexOf(character) !== -1) {
          allowedCharacter = false;
        }
      }

      return allowedCharacter;
    },
    intlphonechars(eventObject, pastedText) {
      if (pastedText) {
        return isMatch(pastedText, INTL_PHONE_CHARACTERS_REGEX);
      }
      return isAllowed(eventObject, INTL_PHONE_CHARACTERS, ALLOW_CONTROL_CHARACTERS);
    },
  };

  function add(inputId, filterType) {
    let element = elements[inputId];
    let uiElementScope;
    const $input = $$$(inputId);

    if (!filters[filterType]) {
      console.log(`xoom.form.Filters.add: There is no filter of type ${filterType}`);
      return;
    }

    if (!element) {
      element = [];
      elements[inputId] = [];

      /* FYI: Key events do not work on Android */
      $input
        .keypress(filterElement)
        .bind('paste', filterPaste)
        .bind('drop', filterDrop);
    }

    element.push(filters[filterType]);

    if ($input.isChildOf('.xoom-dialog')) {
      uiElementScope = 'xoom-dialog';
    }

    xoom.UIManager.register(inputId, {
      destroy() {
        remove(inputId);
      },
    }, uiElementScope);
  }

  xoom.form.Filters = {
    /**
       Filter keypresses in a form field to prevent from entering disallowed characters
       @method add
       @param {String} inputId ID of input element to which we will bind
       @param {String} filterType ["currency"|"numbers"]
       @public
       */
    add(inputId, filterType) {
      add(inputId, filterType);
    },
    /**
       Remove a Filter in a form field
       @method remove
       @param {String} elementId ID of input element to which we will bind
       @public
       */
    remove(elementId) {
      remove(elementId);
    },
  };
  return xoom;
};

export default init;
